import { gsap } from "gsap";
import { DeviceChecker } from './deviceChecker';

const deviceChecker = new DeviceChecker();

/**
 * hoverした時のアニメーションクラス
 */
export class hover {
	constructor() {
		this._init();
	}

	/**
	 * 初期化
	 * - media07 と media10 の hover イベントを設定
	 * - ウィンドウリサイズ時に再設定
	 */
	_init() {
		this._media10Hover();
		this._media07Hover();

		$(window).on('resize', deviceChecker._debounce(() => {
			this._media10Hover();
			this._media07Hover();
		}, 200));
	}

	/**
	 * media07 アイテムの hover アニメーション
	 */
	_media07Hover() {
		$('.media07_item').each((index, element) => {
			const $element = $(element);
			const $elemImgBack = $element.find('.media07_item_img_back');

			gsap.set($elemImgBack, {
				scale: 1.2
			});

			if (deviceChecker._isPc()) {
				$element.on('mouseenter', () => {
					gsap.to($elemImgBack, {
						opacity: 1,
						scale: 1,
						duration: 0.3,
						ease: 'power1.inOut',
					});
				}).on('mouseleave', () => {
					gsap.to($elemImgBack, {
						opacity: 0,
						scale: 1.2,
						duration: 0.3,
						ease: 'power1.inOut',
					});
				});
			}
		});
	}

	/**
	 * media10 アイテムの hover アニメーション
	 */
	_media10Hover() {
		$('.media10_item').each((index, element) => {
			const $element = $(element);
			const $elemTextArea = $element.find('.media10_item_textarea');

			if (deviceChecker._isPc()) {
				$element.on('mouseenter', () => {
					gsap.to($elemTextArea, {
						y: 0,
						duration: 0.3,
						ease: 'power1.inOut',
					});
				}).on('mouseleave', () => {
					gsap.to($elemTextArea, {
						y: '100%',
						duration: 0.3,
						ease: 'power1.inOut',
					});
				});
			}
		});
	}
}
